module.exports = __webpack_public_path__ + "static/media/reading-boomer.1a978561.png";